import {isNullOrUndefined} from "../../../services/Validator";

export default function GlossaryDetailedSubHeaderButton({text, onButtonPressed, isSelected}) {
    // Used in GlossaryDetailedScreenSubHeader to display
    // on single button

    // BUILD
    if (isNullOrUndefined(text) || isNullOrUndefined(onButtonPressed))
        return null
    return (
        <button className={`text-[14px] font-medium relative z-10 flex-1 py-2 text-center transition-colors duration-300 ${
            isSelected ? "text-whiteDark8" : "text-greyLight5"}`}
                onClick={onButtonPressed}>
            {text}
        </button>
    );
}